/*
 * @Copyright: Copyright (c) Pray LLC. All rights reserved.
 * @Author: Raguvind Tharanitharan
 * @Date: 2022-09-12 10:18:12
 * @Last Modified by: Raguvind Tharanitharan
 * @Last Modified time: 2022-09-12 22:12:00
*/

import React, { createElement } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { Toolbar, Typography, Divider, Drawer } from '@mui/material';
import { ListItemIcon, MenuItem, Grid } from '@mui/material';
import * as MuiIcons from "@mui/icons-material";
import '../styles/local-style.css';
import { PrayLink, PrayView } from '../../common';

const drawerWidth = 240;

export default function Sidebar() {
  const settings = useSelector((state) => state.settings);
  const location = useLocation();
  const pathname = location.pathname;
  let selectedId = -1;
  if (settings.features != null) {
    settings.features.map((item) => {
      item.links.map((link) => {
        if (link.link === pathname) {
          selectedId = item.id;
        }
        return null;
      });
      return null;
    });
  }

  const renderSideMenuItem = (item) => {
    return (<PrayLink key={item.id} to={item.link} style={{ textDecoration: 'none', backgroundColor: 'red', mx: 1 }} text={item.name}>
      <MenuItem sx={{ mx: 0.7, borderRadius: 1.5, py: 1.5, pl: 1.3, background: (item.link === pathname) ? '#FFC1073F' : '#FFFFFF00' }}>
        {(item.link === pathname) && <div className='active-indicator' />}
        <ListItemIcon>
          {createElement(MuiIcons[item.icon], { style: { color: "#3C3C3D", opacity: 0.8, fontSize: 22 } })}
        </ListItemIcon>
        <Typography variant="h5" sx={{ ml: -0.9 }}>{item.name}</Typography>
        {item.preview && <div className='free-badge'>{createElement(MuiIcons['Lock'], { style: { color: "#3C3C3D", fontSize: 15, paddingTop: 5, paddingRight: 5, opacity: 0.3 } })}</div>}
      </MenuItem>
    </PrayLink>);
  };

  const renderSideMenu = (item) => {
    return (<Grid key={item.id} sx={{ mx: 1.5, borderRadius: 1.5, background: (item.id === selectedId) ? '#E3AF4A1F' : '#FFFFFF00', pb: 0.5, minHeight: 50, mb: 1 }}>
      <Typography variant="h4" sx={{ opacity: 1, ml: 1.8, mt: 1.8, mb: (item.subtitle === null) ? 0 : 0 }}>{item.title}</Typography>
      {(item.subtitle !== null) && <Typography variant="h6" sx={{ opacity: 1, ml: 1.8, mb: 0.6 }}>{item.subtitle}</Typography>}
      {item.links.map((link) => renderSideMenuItem(link))}
    </Grid>);
  };

  return (
    <PrayView disableEvent={true}>
      <Drawer variant="permanent"
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          [`& .MuiDrawer-paper`]: { width: drawerWidth, boxSizing: 'border-box', backgroundColor: 'var(--ds-surface, #FAFBFC)' },
        }}
      >
        <Toolbar />
        <Grid container sx={{ pb: 1, pl: 2, mt: 1 }}>
          {/* <Avatar sx={{ bgcolor: '#FFC107', color: '#000' }} variant="rounded">
          {createElement(MuiIcons['Church'])}
        </Avatar>
        <Grid sx={{ px: 1.5, flex: 1, m: 'auto' }}>
          <Typography variant="h4" sx={{ opacity: 1 }}>ALFC</Typography>
          <Typography variant="h6" sx={{ opacity: 1 }}>Adam Mesa</Typography>
        </Grid> */}
          {/* <Grid>
          <IconButton
            size='large'
            aria-label='show 17 new notifications'
            color='inherit'
          >
            <ArrowDropDown sx={{ fontSize: 20 }} />
          </IconButton>
        </Grid> */}
        </Grid>
        {(settings.features != null) && settings.features.map((item) => renderSideMenu(item))}
        <Grid sx={{ flex: 1 }} />
        <Typography variant='h5' sx={{ textAlign: 'center', mb: 0.5 }}>Analytic Studio</Typography>
        <Divider sx={{ mx: 8, mb: 0.2 }} />
        <Typography variant="subtitle2" sx={{ textAlign: 'center', fontWeight: 400, px: 4, py: 0.7, fontSize: 10 }}>Part of pray.com suite of products</Typography>
      </Drawer>
    </PrayView>
  );
};
